import { render, staticRenderFns } from "./recruiterKpiContent.vue?vue&type=template&id=59575f01&scoped=true"
import script from "./recruiterKpiContent.vue?vue&type=script&lang=js"
export * from "./recruiterKpiContent.vue?vue&type=script&lang=js"
import style0 from "./recruiterKpiContent.vue?vue&type=style&index=0&id=59575f01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59575f01",
  null
  
)

export default component.exports